import { render } from "./LoadingVue.vue?vue&type=template&id=0396b405&scoped=true"
const script = {}

import "./LoadingVue.vue?vue&type=style&index=0&id=0396b405&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0396b405"]])

export default __exports__